import { render, staticRenderFns } from "./paid-record.vue?vue&type=template&id=087349fb&scoped=true"
import script from "./paid-record.vue?vue&type=script&lang=ts"
export * from "./paid-record.vue?vue&type=script&lang=ts"
import style0 from "./paid-record.vue?vue&type=style&index=0&id=087349fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087349fb",
  null
  
)

export default component.exports